import { Controller } from '@hotwired/stimulus';
import { isPanelOpen, setPanelOpen } from '../lib/disclosure_panel';

export default class extends Controller {
  static targets = ['panel'];
  static values = { accordion: Boolean, openIfChecked: Boolean };

  connect() {
    if (!this.openIfCheckedValue) return;

    this.panelTargets.forEach((panel) => {
      if (panel.querySelector('input:checked'))
        setPanelOpen(panel, true, false);
    });
  }

  closeOthers({ detail: { panel } }) {
    if (!this.accordionValue) return;

    this.panelTargets.forEach((other) => {
      if (other !== panel && isPanelOpen(other)) setPanelOpen(other, false);
    });
  }
}
